import axios from "../../../api/axios";

export const getAllHistory = async ({ accessToken }) => {
  // console.log("getAllHistory called with accessToken:", accessToken);

  const { data } = await axios.get("/guest/getAll", {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  console.log("getAllHistory response data:", data);

  return data;
};
